// extracted by mini-css-extract-plugin
export var headerCell = "_5g-1";
export var loadingSpinnerContainer = "_5g-4";
export var loadingStateCell = "_5g-5";
export var rowWrapper = "_5g-3";
export var standaloneTable = "_5g-6";
export var table = "_5g-0";
export var white = "_5g-2";